import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionsPanelComponent } from './components/transport-options-panel/transport-options-panel.component';
import { TransportOptionEntryComponent } from './components/transport-option-entry/transport-option-entry.component';
import { TransportOptionParameterComponent } from './components/transport-option-parameter/transport-option-parameter.component';
import { TransportOptionParameterSelectionComponent } from './components/transport-option-parameter-selection/transport-option-parameter-selection.component';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule as MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    TransportOptionsPanelComponent,
    TransportOptionEntryComponent,
    TransportOptionParameterComponent,
    TransportOptionParameterSelectionComponent,
    TransportOptionParameterComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    CommonUIModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatCheckboxModule
  ],
  exports: [
    TransportOptionsPanelComponent

  ]
})
export class TransportOptionsPanelModule { }
